import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { ERepeatPolicy, RepeatableRequest, RequestCancelError } from '@cian/valuation-utils-component';

import { selectPayment } from '../../../selectors/payment';
import { getPaymentStatus } from '../../../actions/paymentStatus';
import { PAYMENT_STATUS_UPDATE_INTERVAL } from '../constants';
import { TThunkDispatch } from '../../../types/redux';
import { EPaymentStatus } from '../../../types/payment';

/**
 * Если платеж в статусе Unpaid (ожидаем платежа) - запускаем
 * переодический опрос статуса платежа с отпиской при изменении статуса
 * или размонтировании компонента
 */
export function usePaymentStatusSubscription(): void {
  const dispatch = useDispatch<TThunkDispatch>();
  const { paymentId, paymentStatus } = useSelector(selectPayment);

  /* istanbul ignore next */
  useEffect(() => {
    if (paymentStatus !== EPaymentStatus.Unpaid) {
      return;
    }

    const updateService = new RepeatableRequest({
      repeatPolicy: ERepeatPolicy.Always,
      maxRepeatCount: 0,
      maxRepeatInterval: PAYMENT_STATUS_UPDATE_INTERVAL,
      repeatInterval: PAYMENT_STATUS_UPDATE_INTERVAL,
    });

    try {
      updateService.start(
        () => dispatch(getPaymentStatus(paymentId as string)),
        () => {},
      );
    } catch (error) {
      if (error instanceof RequestCancelError) {
        return;
      }
      throw error;
    }

    return () => {
      updateService.cancel();
    };
  }, [paymentStatus, paymentId, dispatch]);
}
